module.exports = __webpack_public_path__ + "img/1.724bfb82.png";